<template>
  <div>
    <el-page-header @back="goBack" style="margin:10px" content="公告新增">
    </el-page-header>
    <hr />
    <el-form
      style="margin-left:5%;height:600px;overflow-y:scroll"
      :model="ruleForm"
      ref="ruleForm"
      label-width="130px"
      class="demo-ruleForm"
    >
      <el-form-item label="通知类型:">
        <el-select
          v-model="ruleForm.noticeType"
          style="width:80%"
          disabled
          size="small"
          placeholder="请选择通知类型"
        >
          <el-option label="通知公告" :value="0"></el-option>
          <el-option label="整改通知" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="接收人员:">
        <tree-common
          ref="treeCommon"
          style="width:80%"
          :treeData="allTeachers"
        ></tree-common>
      </el-form-item>
      <el-form-item label="通知公告标题:">
        <el-input
          v-model.trim="ruleForm.noticeAnnouncement.notificationTitle"
          style="width:80%"
          clearable
          size="small"
          placeholder="请输入通知公告标题"
        ></el-input>
      </el-form-item>
      <el-form-item label="红头:">
        <el-input
          v-model.trim="ruleForm.noticeAnnouncement.redHead"
          style="width:80%"
          clearable
          size="small"
          placeholder="请输入红头"
        ></el-input>
      </el-form-item>
      <el-form-item label="通知公告内容:">
        <el-input
          v-model.trim="ruleForm.noticeAnnouncement.notificationContent"
          style="width:80%"
          clearable
          size="small"
          type="textarea"
          :autosize="{minRows: 3}"
          placeholder="请输入通知公告内容"
        ></el-input>
      </el-form-item>
      <el-form-item label="附件上传:">
        <span>（附件最多上传10个，大小不得超过10M）</span>
        <file-up-load
          @change="imageChange"
          v-model="imgs"
          :uploadLimit="10"
          style="width:80%;"
        ></file-up-load>
      </el-form-item>
    </el-form>
    <hr />
    <div style="margin-left:20px">
      <el-button type="primary" size="small" @click="saveClick">提交</el-button>
      <el-button type="primary" plain size="small" @click="goBack"
        >取消</el-button
      >
    </div>
  </div>
</template>
<script>
import FileUpLoad from './FileUpload'
import TreeCommon from '@/components/TreeCommon'
export default {
  name: 'ImprovingNoticeAdd',
  components: {
    FileUpLoad,
    TreeCommon,
  },
  data() {
    return {
      imgs: '',
      ruleForm: {
        noticeType: 0,
        noticeAnnouncement: {
          notificationTitle: '', //通知公告标题
          notificationContent: '', //通知公告内容
          redHead: '', //红头
          schoolId: this.$store.state.schoolId, //所属学校
          whetherToDeposit: 0, //是否存为草稿0.否1.是
          publisherId: this.$store.getters.getUserInfo.userId, //发布人id
        },
        noticeAnnexList: [], //附件  attachmentPath附件路径
        noticeReceiverList: [], //接收人员  recipientId接收人id
      },
      allTeachers: [], //
    }
  },
  mounted() {
    this.getAllTeachers()
  },
  methods: {
    async getAllTeachers() {
      let req = {
        pageSize: 10000,
        pageNum: 1,
        schoolId: parseInt(this.$store.state.schoolId),
        departmentId: '',
        userPhone: '',
        userName: '',
      }
      let res = await this.$Http.getTeacherList(req, true)
      if (res.code == 200) {
        if (res.data) {
          let data = res.data.list || []
          let newData = data.map((item) => {
            let obj = {
              label: item.Name || '',
              id: item.id || '',
              leve: '2',
            }
            return obj
          })
          if (data.length > 0) {
            this.allTeachers = [
              {
                label: '全部',
                id: '00',
                leve: '1',
                children: newData,
              },
            ]
          }
        } else {
          this.allTeachers = []
        }
      } else if (res.code == 101) {
        this.allTeachers = []
      } else {
        this.allTeachers = []
      }
    },
    goBack() {
      this.$emit('goBack',false)
    },
    // 图片选择
    imageChange(val) {
      this.ruleForm.noticeAnnexList = val.map((item) => {
        let obj = {
          attachmentPath: item || '',
        }
        return obj
      })
    },
    saveClick() {
      if (this.ruleForm.noticeAnnouncement.notificationTitle == '') {
        this.$message({
          type: 'warning',
          message: '请输入通知公告标题',
        })
        return
      }
      if (this.ruleForm.noticeAnnouncement.notificationContent == '') {
        this.$message({
          type: 'warning',
          message: '请输入通知公告内容',
        })
        return
      }
      let data = this.$refs.treeCommon.$refs.tree.getCheckedKeys()
      this.ruleForm.noticeReceiverList = data.map((item) => {
        let obj = {
          recipientId: item,
        }
        return obj
      })
      if (this.ruleForm.noticeReceiverList.length == 0) {
        this.$message({
          type: 'warning',
          message: '请选择接收人员',
        })
        return
      }
      if (this.ruleForm.noticeAnnexList.length == 0) {
        this.$message({
          type: 'warning',
          message: '请选择附件',
        })
        return
      }
      this.addAnnouncementInfo()
    },
    async addAnnouncementInfo() {
      let req = Object.assign({}, this.ruleForm)
      let res = await this.$Http.addAnnouncementInfo(req)
      if (res.code == 200) {
        this.$message({
          type: 'success',
          message: '新增成功',
        })
      this.$emit('goBack',true)
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: 'error',
          message: '新增失败',
        })
      }
    },
  },
}
</script>
